export default "__VITE_ASSET__D_3D4Qkd__"